jQuery(document).ready(function($) {

    /**
     * Initialize Foundation Library
     */
    $(document).foundation();

    /**
     * Off-Canvas Toggle Event Handler
     *
     * Opens/closed the off-canvas menu when the menu toggle is clicked.
     */
    $('#off-canvas-toggle').on('click', function(e) {
        var $target = $('#the-header'), $menu = $('#off-canvas-menu');

        e.preventDefault();

        if(!$target.hasClass('open')) {

            showOffCanvasMenu($target, $menu);

        } else {

            hideOffCanvasMenu($target, $menu);

        }

    });

    /**
     * Exit Off-Canvas Event Handler
     *
     * Closes the off-canvas menu when anything outside the menu is clicked.
     */
    $('#exit-off-canvas').on('click', function(e) {
        var $target = $('#the-header'), $menu = $('#off-canvas-menu');

        e.preventDefault();

        hideOffCanvasMenu($target, $menu);

    });

    /**
     * Exit Off-Canvas Event Handler
     *
     * Closes the off-canvas menu when the "escape" key is pressed and the menu is open.
     */
    $(document).keydown(function(e) {
        var $target = $('#the-header'), $menu = $('#off-canvas-menu');

        if(e.keyCode == 27 && $target.hasClass('open')) {

            hideOffCanvasMenu($target, $menu);

        }

    });

    /**
     * Collapseable Nav Listener
     *
     * Adds/removes the "active" class to/from the given anchor.
     */
    $('.menu-item-has-children').on('click', 'a', function(e) {
        var $chevron = $(e.target).find('.fa');

        $(e.target).toggleClass('active');

        // change the menu chevron-icon
        if($chevron.hasClass('fa-chevron-down')) {

            $chevron.toggleClass('fa-chevron-down');
            $chevron.addClass('fa-chevron-up');

        } else {

            $chevron.toggleClass('fa-chevron-up');
            $chevron.addClass('fa-chevron-down');

        }

    });

    /**
     * Collapseable Mobile Nav Listener
     *
     * Opens/closes collapaseable mobile navigation menus.
     */
    $('.mobile-nav .menu-item-has-children > a').on('click', function(e) {

        // prevent link from firing (if set)
        e.preventDefault();

        // toggle the sub-menu
        $(e.target).next('.sub-menu').slideToggle(100);

    });

    /**
     * Sticky Header Listener
     * 
     * Adds/removes the "fixed" class to the page header which sets its position 
     * to fixed/relative as necessary.
     */
    $(window).scroll(function() {
        var $target = $('body'), $offset = $(window).scrollTop(), className = 'fixed';

        if($offset > 0 && !$target.hasClass(className)) {
 
            $target.addClass(className);
 
        } else if($offset === 0 && $target.hasClass(className)) {
 
            $target.toggleClass(className);
 
        }
 
    });

    /**
     * Show Off Canvas Menu
     *
     * Handles the logic that displays the mobile nav.
     * 
     * @param $target
     * @param $menu
     */
    function showOffCanvasMenu($target, $menu) {

        $target.addClass('open');
        $('#exit-off-canvas').addClass('open');

        $menu.show();

    }

    /**
     * Hide Off Canvas Menu
     *
     * Handles the logic that hides the mobile nav.
     * 
     * @param $target
     * @param $menu
     */
    function hideOffCanvasMenu($target, $menu) {

        $target.toggleClass('open');
        $('#exit-off-canvas').toggleClass('open');

        $menu.hide();

    }

});